module.exports = __webpack_public_path__ + "static/about3-134febad68554790c735d8d4103098b8.png";